export default __webpack_public_path__ + "static/media/abc.fb26b258.pdf";